import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { Carousel } from '@infl-ts/ui-advocate-components';
import { useToggle } from '@infl-ts/util-hooks';
import { NavigateBefore, NavigateNext } from '@mui/icons-material';
import { Box, Fab, fabClasses, styled, Typography } from '@mui/material';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledCarousel = styled(Carousel)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column-reverse;\n\n  & .indicator > svg {\n    width: ", ";\n    height: ", ";\n  }\n\n  & .indicator {\n    color: ", ";\n    padding: 0;\n  }\n\n  .active-indicator {\n    color: ", ";\n  }\n\n  &:hover .navigation-button > .", " {\n    opacity: 1 !important;\n    color: ", " !important;\n    background-color: ", " !important;\n    margin: 0 ", ";\n  }\n\n  & .indicator-container {\n    order: -1;\n  }\n"])), function (p) {
  return p.theme.spacing(1.5);
}, function (p) {
  return p.theme.spacing(1.5);
}, function (p) {
  return p.theme.palette.action.disabled;
}, function (p) {
  return p.theme.palette.primary.main;
}, fabClasses.root, function (p) {
  return p.theme.palette.secondary.contrastText;
}, function (p) {
  return p.theme.palette.secondary.light;
}, function (p) {
  return p.theme.spacing(1);
});
export var CarouselWrapper = function CarouselWrapper(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      position: 'relative'
    },
    "data-element": "Box",
    "data-component": "CarouselWrapper",
    "data-source-file": "challenge-carousel.tsx",
    children: [title && /*#__PURE__*/_jsx(Translation, {
      children: function children(t) {
        return /*#__PURE__*/_jsx(Typography, {
          variant: "h2",
          sx: {
            mb: 2,
            position: 'relative'
          },
          children: t(title)
        });
      }
    }), children]
  });
};

var ChallengeCarousel = function ChallengeCarousel(_ref2) {
  var children = _ref2.children,
      showIndicators = _ref2.showIndicators,
      title = _ref2.title;

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      animationEnabled = _useToggle2[0],
      enableAnimation = _useToggle2[1].on;

  return /*#__PURE__*/_jsx(CarouselWrapper, {
    title: title,
    "data-element": "CarouselWrapper",
    "data-component": "ChallengeCarousel",
    "data-source-file": "challenge-carousel.tsx",
    children: /*#__PURE__*/_jsx(StyledCarousel, {
      animation: "slide",
      autoPlay: false,
      changeOnFirstRender: false,
      swipe: true,
      indicators: showIndicators,
      cycleNavigation: false,
      timeout: {
        appear: 0,
        enter: animationEnabled ? 300 : 0,
        exit: animationEnabled ? 300 : 0
      },
      indicatorContainerProps: {
        className: 'indicator-container',
        style: {}
      },
      indicatorIconButtonProps: {
        className: 'indicator',
        style: {}
      },
      activeIndicatorIconButtonProps: {
        className: 'active-indicator',
        style: {}
      },
      navButtonsWrapperProps: {
        className: 'navigation-button',
        style: {}
      },
      NavButton: function NavButton(_ref3) {
        var next = _ref3.next,
            className = _ref3.className,
            _onClick = _ref3.onClick;
        return /*#__PURE__*/_jsx(Fab, {
          className: className,
          onClick: function onClick() {
            enableAnimation();

            _onClick();
          },
          "aria-label": "navigate",
          sx: {
            zIndex: function zIndex(t) {
              return t.zIndex.popover;
            }
          },
          children: next ? /*#__PURE__*/_jsx(NavigateNext, {}) : /*#__PURE__*/_jsx(NavigateBefore, {})
        });
      },
      "data-element": "StyledCarousel",
      "data-component": "ChallengeCarousel",
      "data-source-file": "challenge-carousel.tsx",
      children: children
    })
  });
};

export default ChallengeCarousel;